import BigNumber from 'bignumber.js';
export * from 'bignumber.js';
export const bn = (n, base = 10) => new BigNumber(n, base);
export const bnOrZero = (n) => {
    const value = bn(n || 0);
    return value.isFinite() ? value : bn(0);
};
export const positiveOrZero = (n) => {
    const value = bn(n || 0);
    return value.isPositive() ? value : bn(0);
};
export const convertPrecision = ({ value, inputExponent = 0, outputExponent = 0, }) => {
    return bnOrZero(value)
        .dividedBy(bn(10).exponentiatedBy(inputExponent))
        .multipliedBy(bn(10).exponentiatedBy(outputExponent));
};
